/* eslint-disable max-len,max-len */

import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

//10000 errors are our own created in desktop doftware
//11000 errors are created on the front end and are generally to do with the socket
//rest are LaMotte errors

/* eslint-enable max-len */

export function getErrorCode(code, scannerName = null, includeCode = true) {

  let errorCodeDescription = getErrorList();

  try {
    if(code !== -1 && code !== -11) {
      code = Math.abs(code);
    }
  } catch (e) {
    console.log('Error Code Error', e);
  }
  if (errorCodeDescription[code]) {
    if (scannerName) {
      scannerName =  scannerName === 'SmartLab' ? 'Smart Lab 1' : scannerName;
      scannerName =  !!scannerName && scannerName.toString().indexOf('Spin Touch') >= 0 ? 'Smart Lab 2' : scannerName;

      return (
        <span>
          <FormattedMessage id={errorCodeDescription[code]}
                            values={{scannerName}}/>
          {includeCode ? <div><FormattedMessage id={'error.code'}
                                                values={{code: getErrorCodeAbv(code)}}/></div> : null}
        </span>);
    }
    return (
      <span>
        <FormattedMessage id={errorCodeDescription[code]}/>
        {includeCode ? <div><FormattedMessage id={'error.code'}
                                              values={{code: getErrorCodeAbv(code)}}/></div> : null}
      </span>);
  }

  if (code >= 257 && code <= 512) {
    return (
      <span><FormattedMessage id={errorCodeDescription.defaultOverfill}/>
        {includeCode ? <div><FormattedMessage id={'error.code'}
                                              values={{code: getErrorCodeAbv(code)}}/></div> : null}
      </span>);
  }
  if (code < 10000) {
    return (
      <span><FormattedMessage id={errorCodeDescription.defaultLamotte}/>
        {includeCode ? <div><FormattedMessage id={'error.code'}
                                              values={{code: getErrorCodeAbv(code)}}/></div> : null}
      </span>);
  }
  return (
    <span><FormattedMessage id={errorCodeDescription['defaultFrontEnd']}/>
      {includeCode ? <div><FormattedMessage id={'error.code'}
                                            values={{code: getErrorCodeAbv(code)}}/></div> : null}
    </span>);
}

export function getErrorCodeText(code, scannerName) {
  let errorCodeDescription = getErrorList();

  try {
    if(code !== -1 && code !== -11) {
      code = Math.abs(code);
    }
  } catch (e) {
    console.log('Error Code Error', e);
  }
  if (errorCodeDescription[code]) {
    if (scannerName) {
      return <FormattedMessage id={errorCodeDescription[code]}
                                values={{scannerName}}/>;
    } else {
      return <FormattedMessage id={errorCodeDescription[code]}/>;
    }
  } else {
    if (code >= 257 && code <= 512) {
      return <FormattedMessage id={errorCodeDescription['defaultOverfill']}/>;
    } else if (code < 10000) {
      return <FormattedMessage id={errorCodeDescription['defaultLamotte']}/>;
    } else {
      return <FormattedMessage id={errorCodeDescription['defaultFrontEnd']}/>;
    }
  }
}

export const ScanningErrors = {
  TCSMARTLAB_OPTIONS: 99999,
  TCSMARTLAB_WATERTEST: 99999,
  TCSMARTLAB_SCANNEROFFLINE: 10001,
  TCSMARTLAB_REAGENTNOTAVAILABLE: 10002,
  TCSMARTLAB_SAMPLENOTAVAILABLE: 10002,
  TCSMARTLAB_SCANNERBUSY: 10003,
  TCSMARTLAB_SERVICEOFFLINE: 10004,
  XFC_SERVICEOFFLINE: 10005,
  XFC_INVALID_STRIPS: 10006,
  XFC_UNEXPECTED_ERROR: 10007,
  XFC_INVALID_FIELDS: 10008,
  XFC_INVENTORY_ERROR: 10009,
};

const getErrorList = (formatMessage) => {
  //Errors -1 and -11 share the message
  //Errors 5 and 15 share the message
  let ret = {
    1001: 'error.code.01001',
    1002: 'error.code.01002',
    1003: 'error.code.01003',
    1004: 'error.code.01004',
    1011: 'error.code.01011',
    1013: 'error.code.01013',

    2001: 'error.code.02001',
    2002: 'error.code.02002',
    2003: 'error.code.02003',
    2004: 'error.code.02004',
    2011: 'error.code.02011',
    2013: 'error.code.02013',

    11001: 'error.code.11001',
    11002: 'error.code.11002',
    11003: 'error.code.11003',
    11004: 'error.code.11004',
    99999: 'error.code.99999',
    10001: 'error.code.10001',
    10002: 'error.code.10002',
    10003: 'error.code.10003',
    10004: 'error.code.10004',
    10005: 'error.code.10005',
    10006: 'error.code.10006',
    10007: 'error.code.10007',
    10008: 'error.code.10008',
    10009: 'error.code.10009',
    88888: 'error.code.88888',
    501: 'error.code.501',
    502: 'error.code.502',
    503: 'error.code.503',
    999: 'error.code.999',
    1: 'error.code.1',
    2: 'error.code.2',
    3: 'error.code.3',
    4: 'error.code.4',
    5: 'error.code.5',
    15: 'error.code.5',
    6: 'error.code.6',
    7: 'error.code.7',
    8: 'error.code.8',
    11: 'error.code.11',
    13: 'error.code.13',
    9: 'error.code.defaultLamotte',
    42: 'error.code.defaultLamotte',
    256: 'error.code.256',
    '-1': 'error.code.-1',
    '-11': 'error.code.-1',
    defaultLamotte: 'error.code.defaultLamotte',
    defaultFrontEnd: 'error.code.defaultFrontEnd',
    defaultOverfill: 'error.code.defaultOverfill',
  };

  for(let errName in ScanningErrors) {
    let errCode = ScanningErrors[errName];

    ret[errCode] = 'error.code.' + errCode.toString();
  }

  return ret;
};


function getErrorCodeAbv(code) {
  if (code > 10000) {
    return 'ALEX(' + code + ')';
  } else if (code < 10000) {
    return 'Lamotte(' + code + ')';
  } else {
    return 'Unknown';
  }
}

export const validNegativeErrorCodes = [-11, -1];